// TooltipPortal.js
import React, { useEffect, useRef } from "react";
import "./TooltipPortal.css";
import { createPortal } from "react-dom";

const TooltipPortal = ({ anchorRef, show, children }) => {
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (show && anchorRef.current && tooltipRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      tooltipRef.current.style.position = "fixed";
      // position tooltip centered horizontally on the anchor
      tooltipRef.current.style.left = rect.left + rect.width / 2 + "px";
      // place tooltip below the anchor (small offset)
      tooltipRef.current.style.top = rect.bottom - 60 + "px";
      tooltipRef.current.style.transform = "translateX(-50%)";
      tooltipRef.current.style.zIndex = 11000;
      // allow pointer events so tooltip can be hovered if needed
      tooltipRef.current.style.pointerEvents = "auto";
    }
  }, [show, anchorRef]);

  if (!show) return null;

  return createPortal(
    <div ref={tooltipRef} className="tooltipportal">
      {children}
    </div>,
    document.body
  );
};

export default TooltipPortal;
